import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { getAttribution } from "@/components/Analytics";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
    } catch {
      setUser(null);
      setCompany(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.needs_verification) return data;
    localStorage.setItem("pt_token", data.token);
    await refresh();
    return data.user;
  };

  const register = async (name, email, password, draftId, ideaMailOptIn = false, ideaMailConsentText = IDEA_MAIL_TEXT) => {
    const { data } = await api.post("/auth/register", { name, email, password, draft_id: draftId, attribution: getAttribution(), idea_mail_opt_in: ideaMailOptIn, idea_mail_consent_text: ideaMailOptIn ? ideaMailConsentText : null });
    return data;
  };

  const verifyEmail = async (email, code) => {
    const { data } = await api.post("/auth/verify-email", { email, code });
    localStorage.setItem("pt_token", data.token);
    await refresh();
    return data.user;
  };

  const resendCode = async (email) => {
    const { data } = await api.post("/auth/resend-code", { email });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pt_token");
    setUser(null);
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ user, company, loading, login, register, verifyEmail, resendCode, logout, refresh, setCompany, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const RETURN_TO_KEY = "aicom_return_to";
export const getReturnTo = () => sessionStorage.getItem(RETURN_TO_KEY);

export const IDEA_MAIL_MAIN = "Ja tak, send mig samtidig en mail med 3 skarpe forslag til SoMe-opslag hver mandag morgen.";
export const IDEA_MAIL_SUB = "Skræddersyet til din virksomhed. Afmeld når som helst med et klik.";
export const IDEA_MAIL_TEXT = `${IDEA_MAIL_MAIN} ${IDEA_MAIL_SUB}`;
export const ideaMailText = (company) => `Ja tak, send mig 3 forslag til SoMe-opslag m.m. hver mandag, skrevet til ${company || "jeres virksomhed"}. Afmeld med ét klik.`;
